/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, mixins } from '@blend/consumer-components';
import { Wrapper } from '../FieldSet';
import { Checkbox } from '../Checkbox/Checkbox';
import { Choice } from '../../TaskInputs/types';
import { map, includes, intersection, xor } from '@utils/lodash';

type MultiCheckboxValue = any;

export interface MultiCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

export namespace MultiCheckbox {
  export interface Props extends React.HTMLAttributes<HTMLInputElement> {
    name: string;
    legend: string;
    choices: Choice[];
    value: MultiCheckboxValue;
    onChange(value: MultiCheckboxValue | null): void;
  }
}
const rowSpacing = 12;

const styles = StyleSheet.create({
  componentWrapper: {
    marginLeft: 10,
  },
  choices: {
    ...mixins.margin(rowSpacing, 5, rowSpacing, 5),
    backgroundColor: colors.white,
  },
});

export const MultiCheckbox: React.SFC<MultiCheckbox.Props> = ({
  value,
  name,
  legend,
  choices,
  onChange,
  ...htmlProps
}) => {
  const allValues = map(choices, choice => choice.value);
  return (
    <Wrapper legend={legend} data-it="MultiCheckbox">
      <div className={css(styles.componentWrapper)}>
        {map(choices, choice => {
          const newValue = intersection(allValues, xor(value, [choice.value]));
          const innerOnChange = () => onChange(newValue.length ? newValue : []);
          const idValue = `${name}-${choice.value}`;
          return (
            <div className={css(styles.choices)}>
              <Checkbox
                {...htmlProps}
                name={name}
                value={`${choice.value}`}
                id={idValue}
                label={choice.text}
                checked={includes(value, choice.value)}
                onChange={innerOnChange}
                type="checkbox"
              />
            </div>
          );
        })}
      </div>
    </Wrapper>
  );
};
